/* eslint-disable max-len */
export default {
  invoiceSubmittedHeader: 'Your application has been submitted!',
  invoiceSubmittedSubHeader:
    'will review your application and we’ll let you know once this is approved and ready to go. In the meantime, you can make bookings using a debit or credit card.',
  invoiceSubmittedCloseBtn: 'Close',
  invoiceSubmittedCreateBookingBtn: 'Create a Booking',
  invoiceSubmittedAddCardBtn: 'Add Card',
};
